var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 30,
    viewBox: "0 0 15 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22587 11.6129C11.2166 11.6129 14.4517 10.8042 14.4517 9.80647C14.4517 8.80879 11.2166 8 7.22587 8C3.23513 8 0 8.80879 0 9.80647C0 10.8042 3.23513 11.6129 7.22587 11.6129Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 17.5517C14.3385 16.6198 11.6162 14.7756 7.91954 13.4324C4.22285 12.0893 0.951622 11.7559 0.613046 12.6877C0.27447 13.6196 2.99676 15.4638 6.69345 16.807C10.3901 18.1501 13.6614 18.4835 13.9999 17.5517Z",
    fill: "#121212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22587 22.0012C11.2166 22.0012 14.4517 21.2935 14.4517 20.4205C14.4517 19.5475 11.2166 18.8398 7.22587 18.8398C3.23513 18.8398 0 19.5475 0 20.4205C0 21.2935 3.23513 22.0012 7.22587 22.0012Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.f99e63d390ca69768285da29940b7b09.svg";
export { ForwardRef as ReactComponent };